<app-main-wrapper>
   <main class="details-container container" [style.opacity]="isBrowser ? 1 : 0">
      <ng-container *ngIf="detailsLoader">
         <div class="details-loader-grid">
            <div class="left-loader-column d-flex flex-column gap-4 align-items-start">
               <div class="d-block skeleton-loader rounded-3 height-10r w-100"></div>
               <div class="d-block skeleton-loader rounded-3 height-20r w-100"></div>
               <div class="d-block skeleton-loader rounded-3 height-30r w-100"></div>
            </div>
            <div class="right-loader-column d-flex flex-column d-grid gap-4 align-items-start">
               <div class="d-block skeleton-loader rounded-3 height-5r w-100"></div>
               <div class="d-block skeleton-loader rounded-3 height-30r w-100"></div>
               <div class="d-block skeleton-loader rounded-3 height-20r w-100"></div>
               <div class="d-block skeleton-loader rounded-3 height-20r w-100"></div>
            </div>
         </div>
      </ng-container>

      <ng-container *ngIf="!detailsLoader">
         <ng-container *ngIf="dataUnavailable">
            <div class="d-flex align-items-center no-data-available-wrapper py-4 px-3 p-lg-4 justify-content-center">
               <p class="mb-0 fw-600 text-center">
                  Data not available for this Stock
               </p>
            </div>
         </ng-container>

         <ng-container *ngIf="!dataUnavailable">
            <div class="mobile-stock-details-wrapper" *ngIf="isMobile && stock.companyProfile">
               <app-company-info [stockName]="stock.companyProfile.name" [reportTypeSection]="reportTypeSection"
                  [reportTypeYear]="reportTypeYear"
                  [stockDescription]="stock.companyProfile.description" [stockLogo]="stock.companyProfile.logo"
                  [stockTicker]="stock.companyProfile.ticker" [fullCountryName]="fullCountryName" [stock]="stock"
                  [type]="type"></app-company-info>
               <section>
                  <app-details-header [item]="stock.companyProfile" [logoUrl]="stock.companyProfile.logo"
                     [stockName]="stock.companyProfile.name" [stockTicker]="stock.companyProfile.ticker"
                     [currentPrice]="fundamentals?.currentPrice" [currency]="stock.companyProfile.currency"
                     [priceChange]="fundamentals?.change" [percentChange]="percentChange"
                     [countryName]="fullCountryName" [sectorName]="stock.companyProfile.musaffaSectorName"
                     [marketCap]="stock.companyProfile.marketCapClassification" [lastDate]="fundamentals.fullDatetime"
                     [stockExchange]="stock.companyProfile.exchange" [isShown]="isShown"
                     [isAddedInWatchlist]="isAddedInWatchlist" [countryCode]="countryName"
                     (openAddLists)="isShown = true" [stockType]="'Stock'" [chartTicker]="chartTicker"
                     [showTradingViewTicker]="showTradingViewChart">
                  </app-details-header>

                  <ng-container *ngIf="isCoveredCountry()">
                     <div class="mobile-sticky-tabs">
                        <app-details-tab-btns [activeTab]="activatedTabIndex" [tabsType]="'bordered'" [tabs]="getTabs()"
                           (onTabChange)="tabChange($event)">
                        </app-details-tab-btns>
                     </div>

                     <div class="py-2 bg-white box-shadow1 fixed-bottom" *ngIf="
                           !isBuySellLoading &&
                           showBuySellComponent &&
                           shariahCompliantStatus
                        ">
                        <app-buysell [symbol]="id" [exchange]="exchangeCode" [userRole]="userRole"
                           [complianceStatus]="shariahCompliantStatus">
                        </app-buysell>
                     </div>

                     <section class="pt-4" [hidden]="!checkSelectedTab(activatedTabIndex, 'Overview')"
                        *ngIf="stock.companyProfile.id">
                        <ng-container>
                           <div class="br-10 mb-4" *ngIf="showChart">
                              <div class="d-flex px-3 align-items-start flex-column flex-lg-row">
                                 <h4 class="company-chart-name mb-0 fw-600">
                                    <span>{{stock.companyProfile.name}} ({{stock.companyProfile.id}})</span>
                                    Chart
                                 </h4>
                                 <!-- <div class="chips-container d-flex align-items-center mt-2 mb-3 flex-nowrap gap-2">
                                    <span
                                       class="stock-chip cursor-pointer d-flex align-items-center ps-2 gap-2 text-nowrap rounded-pill"
                                       *ngIf="fullCountryName" [routerLink]="'/stock-screener'" [queryParams]="{
                                          country: stock.companyProfile.country,
                                          page: 1
                                       }">
                                       <img
                                          [appLazyLoadImage]="'/assets/flags/1x1/' + stock.companyProfile.country?.toLowerCase() + '.svg'"
                                          width="16" height="16" class="img-fluid rounded-circle" priority
                                          [alt]="fullCountryName + ' flag'" />
                                       <span>{{ fullCountryName }}</span>
                                    </span>
                                    <span class="stock-chip cursor-pointer text-nowrap rounded-pill" *ngIf="
                                          stock.companyProfile.musaffaSectorName
                                       " [routerLink]="'/stock-screener'" [queryParams]="{
                                          country: stock.companyProfile.country,
                                          page: 1,
                                          sectors:
                                             stock.companyProfile
                                                .musaffaSectorName
                                       }">
                                       {{
                                       stock.companyProfile.musaffaSectorName
                                       }}
                                    </span>
                                    <span class="stock-chip cursor-pointer text-nowrap rounded-pill" *ngIf="
                                          stock.companyProfile
                                             .marketCapClassification
                                       " [routerLink]="'/stock-screener'" [queryParams]="{
                                          country: stock.companyProfile.country,
                                          page: 1,
                                          marketCapClassification:
                                             stock.companyProfile
                                                .marketCapClassification
                                       }">
                                       {{
                                       stock.companyProfile
                                       ?.marketCapClassification
                                       | categoryToText
                                       | titlecase
                                       }}
                                    </span>
                                 </div> -->
                              </div>

                              <app-trading-view *ngIf="showTradingViewChart" [isMobile]="isMobile"
                                 [symbol]="chartTicker" (hasData)="chartEvent($event)">
                              </app-trading-view>
                              <app-trading-chart *ngIf="!showTradingViewChart" [ticker]="stock.companyProfile.ticker"
                                 [currency]="stock.companyProfile.currency" (getPrice)="getStartPrice($event)"
                                 (hasData)="chartEvent($event)">
                              </app-trading-chart>
                           </div>
                           <!-- <ng-template #noChart>
                              <app-no-data-card heading="Chart"></app-no-data-card>
                           </ng-template> -->
                        </ng-container>

                        <ng-container>
                           <app-compliance-status-card [stockType]="type" [isin]="stock.companyProfile.isin"
                              [mainTicker]="stock.companyProfile.mainTicker" *ngIf="
                                 shariahCompliantStatus && complianceMetaLoaded
                              " [complianceStatus]="shariahCompliantStatus" [complianceRanking]="
                                 stock.companyProfile.ranking_v2
                              " [complianceRankingV2]="stock.companyProfile.ranking_v2"
                              [ticker]="stock.companyProfile.ticker" [countryCode]="stock.companyProfile.country"
                              [canViewScreeningReport]="canViewScreeningReport" [lastUpdate]="lastUpdate"
                              [reportDate]="reportDate" [reportTypeSection]="reportTypeSection"
                              [reportTypeYear]="reportTypeYear" (goToComplianceTab)="
                                 onGoToComplianceTab(
                                    stock.companyProfile.ticker,
                                    shariahCompliantStatus
                                 )
                              ">
                           </app-compliance-status-card>
                        </ng-container>

                        <ng-container *ngIf="isCoveredCountry()">
                           <app-purification-card [complianceStatus]="shariahCompliantStatus"
                              [stockName]="stock.companyProfile.name" [stockTicker]="stock.companyProfile.ticker">
                           </app-purification-card>
                        </ng-container>

                        <ng-container *ngIf="analystRatingsVisibility">
                           <app-stock-recommendation [ticker]="id" [showLabel]="shariahCompliantStatus == 'COMPLIANT'"
                              [stockname]="stock.companyProfile.name" [stockComplianceRating]="shariahCompliantStatus"
                              id="Analysts-Ratings">
                           </app-stock-recommendation>
                        </ng-container>

                        <div class="mt-32">
                           <app-market-comparison [name]="stock.companyProfile.name"
                              [ticker]="stock.companyProfile.ticker" [data]="stockData"
                              [indexData]="stockIndices"></app-market-comparison>
                        </div>

                        <ng-container *ngIf="keyStatisticsVisibility">
                           <div class="mt-4 mb-4" *ngIf="
                                 stock &&
                                 stock.companyProfile &&
                                 fundamentals &&
                                 fundamentals.todaysOpen
                              ">
                              <app-fundamentals [stock]="stock" [fundamentals]="fundamentals"
                                 [currency]="stock.companyProfile.currency"></app-fundamentals>
                           </div>
                        </ng-container>

                        <!-- <div
                           *ngIf="
                              investmentChecklistVisibility &&
                              showInvestmentChecklist
                           "
                        >
                           <app-investment-checklist
                              *ngIf="shariahCompliantStatus"
                              [ticker]="id"
                              [countryCode]="stock.companyProfile.country"
                              [currency]="currency"
                              [status]="shariahCompliantStatus"
                           >
                           </app-investment-checklist>
                        </div> -->

                        <!-- New one -->
                        <div *ngIf="
                              investmentChecklistVisibility &&
                              showInvestmentChecklist &&
                              countryName === 'US'
                           ">
                           <app-new-investment-checklist *ngIf="shariahCompliantStatus" [ticker]="id"
                              [countryCode]="stock.companyProfile.country" [currency]="currency"
                              [status]="shariahCompliantStatus">
                           </app-new-investment-checklist>
                        </div>

                        <app-superinvestors-stock-overview-list [name]="stock.companyProfile.name" [ticker]="stock.companyProfile.ticker"></app-superinvestors-stock-overview-list>

                        <app-top-user-collections [showSymbolsList]="true" [styleType]="'card'"
                           [symbol]="stock.companyProfile.ticker" [sectionHeading]="'Community-Curated Collections with ' + stock.companyProfile.name + ' (' + stock.companyProfile.ticker + ')'"
                           [showMessage]="false">
                        </app-top-user-collections>

                        <div class="mt-32">
                           <app-faqs [name]="stock.companyProfile.name" [ticker]="stock.companyProfile.ticker" [halalStatus]="halalStatus" [monthYear]="monthYear" [type]="'stock'"></app-faqs>
                        </div>

                        <ng-container *ngIf="relatedStocksVisibility">
                           <app-related-stocks [musaffaIndustryName]="
                                 stock.companyProfile.musaffaIndustryName
                              " [musaffaSectorName]="
                                 stock.companyProfile.musaffaSectorName
                              " [marketCapClassification]="
                                 stock.companyProfile.marketCapClassification
                              " [country]="stock.companyProfile.country" [gsubind]="stock.companyProfile.gsubind"
                              [ticker]="stock.companyProfile.ticker" [complianceStatus]="shariahCompliantStatus"
                              [name]="stock.companyProfile.name"
                              [finnhubIndustry]="
                                 stock.companyProfile.finnhubIndustry
                              " [gsector]="stock.companyProfile.gsector" id="Related-Companies">
                           </app-related-stocks>
                        </ng-container>
                     </section>

                     <section class="pt-4" *ngIf="
                           checkSelectedTab(
                              activatedTabIndex,
                              'Shariah Compliance Report'
                           ) && stock.companyProfile.ticker
                        ">
                        <!-- <app-limit-reached-card></app-limit-reached-card> -->
                        <ng-container *ngIf="showComplianceReport">
                           <div *ngIf="
                                 reportFormat == 'NEW' ||
                                    shariahCompliantStatus == 'LOCKED';
                                 else oldReport
                              ">
                              <app-screener-report [storedResponse]="screenerReportResponse"
                                 (responseLoaded)="screenerDataLoaded($event)" [companyProfile]="stock.companyProfile">
                              </app-screener-report>
                           </div>
                           <ng-template #oldReport>
                              <app-tooltip [profile]="stock.companyProfile" [results]="results"
                                 [position]="tooltipPosition" [renenueRatio]="this.renenueRatio"
                                 [interestBearingSecurities]="
                                    this.interestBearingSecurities
                                 " [interestBearingDebt]="this.interestBearingDebt">
                              </app-tooltip>
                           </ng-template>
                        </ng-container>
                        <ng-container *ngIf="!showComplianceReport">
                           <app-feature-locked-card heading="Shariah Compliance Report"
                              text="An extensive business and financial screening of the company which specifies why a stock is halal or haram!"
                              (viewSampleClicked)="onViewSampleClicked('report')"
                              componentPage="shariah_compliance_report">
                           </app-feature-locked-card>
                        </ng-container>
                     </section>
                     <section class="mt-32" *ngIf="
                           isBrowser &&
                           showIriReport &&
                           checkSelectedTab(activatedTabIndex, 'IRI Report') &&
                           stock.companyProfile.ticker
                        ">
                        <ng-container>
                           <app-iri-report [symbol]="this.stock.companyProfile.ticker" [symbolMainTicker]="
                                 this.stock.companyProfile.mainTicker
                              " [userRoleNew]="userRoleNew" [isSubscribed]="isSubscribed" [country]="stock.companyProfile.country"></app-iri-report>
                        </ng-container>
                     </section>

                     <section class="mt-32" *ngIf="
                           isBrowser &&
                           checkSelectedTab(activatedTabIndex, 'Financials') &&
                           stock.companyProfile.ticker
                        ">
                        <ng-container *ngIf="forecastVisibility">
                           <app-stock-financials [ticker]="stock.companyProfile.ticker"></app-stock-financials>
                           <!-- <div class="" *ngIf="isAllowedCountry; else noForecast">
                              <app-forecasts [ticker]="stock.companyProfile.ticker"
                                 [currency]="stock.companyProfile.currency" [fundamentals]="fundamentals">
                              </app-forecasts>
                           </div>
                           <ng-template #noForecast>
                              <app-no-data-card heading="Forecasts"></app-no-data-card>
                           </ng-template> -->
                        </ng-container>
                     </section>
                     <section class="px-3 pt-4" *ngIf="
                           isBrowser &&
                           checkSelectedTab(activatedTabIndex, 'Forecast') &&
                           stock.companyProfile.ticker
                        ">
                        <ng-container *ngIf="forecastVisibility">
                           <div class="" *ngIf="isAllowedCountry; else noForecast">
                              <app-forecasts [ticker]="stock.companyProfile.ticker"
                                 [currency]="stock.companyProfile.currency" [fundamentals]="fundamentals">
                              </app-forecasts>
                           </div>
                           <ng-template #noForecast>
                              <app-no-data-card heading="Forecasts"></app-no-data-card>
                           </ng-template>
                        </ng-container>
                     </section>

                     <section class="px-3 pt-4" *ngIf="
                           isBrowser &&
                           checkSelectedTab(activatedTabIndex, 'News') &&
                           stock.companyProfile.ticker
                        ">
                        <ng-container *ngIf="newsVisibility">
                           <app-stock-news [ticker]="stock.companyProfile.ticker" id="Latest-News">
                           </app-stock-news>
                        </ng-container>

                        <ng-container *ngIf="pressReleaseVisibility">
                           <app-stock-press-releases [handleHeader]="'show'" [symbol]="stock.companyProfile.ticker"
                              id="Press-Releases">
                           </app-stock-press-releases>
                        </ng-container>
                     </section>

                     <section class="px-3 pt-4" *ngIf="
                           checkSelectedTab(activatedTabIndex, 'Profile') &&
                           stock.companyProfile.ticker
                        ">
                        <app-stock-profile [profileDescription]="
                              stock.companyProfile.description
                           " [market]="stock.companyProfile.country" [sector]="stock.companyProfile.musaffaSectorName"
                           [industry]="stock.companyProfile.musaffaIndustryName"
                           [exchange]="stock.companyProfile.exchange" [website]="stock.companyProfile.weburl"
                           [phone]="stock.companyProfile.phone" [address]="stock.companyProfile.address"
                           [currentPrice]="fundamentals?.currentPrice">
                        </app-stock-profile>
                     </section>
                  </ng-container>

                  <ng-container *ngIf="!isCoveredCountry()">
                     <ng-container *ngIf="
                           shariahCompliantStatus === 'NOT_UNDER_COVERAGE';
                           else coveredComplaiance
                        ">
                        <div class="mobile-sticky-tabs">
                           <app-details-tab-btns [activeTab]="activatedTabIndex" [tabsType]="'bordered'"
                              [tabs]="getTabs()" (onTabChange)="tabChange($event)">
                           </app-details-tab-btns>
                        </div>

                        <section class="" [hidden]="
                              !checkSelectedTab(activatedTabIndex, 'Overview')
                           " *ngIf="stock.companyProfile.ticker">
                           <ng-container>
                              <app-compliance-status-card [stockType]="type" [isin]="stock.companyProfile.isin"
                                 [mainTicker]="stock.companyProfile.mainTicker" *ngIf="
                                    shariahCompliantStatus && complianceMetaLoaded
                                 " [complianceStatus]="shariahCompliantStatus" [complianceRanking]="
                                    stock.companyProfile.ranking_v2
                                 " [complianceRankingV2]="stock.companyProfile.ranking_v2"
                                 [ticker]="stock.companyProfile.ticker" [countryCode]="stock.companyProfile.country"
                                 [canViewScreeningReport]="canViewScreeningReport" [lastUpdate]="lastUpdate"
                                 [reportDate]="reportDate" [reportTypeSection]="reportTypeSection"
                                 [reportTypeYear]="reportTypeYear" (goToComplianceTab)="
                                    onGoToComplianceTab(
                                       stock.companyProfile.ticker,
                                       stock.companyProfile
                                          .shariahCompliantStatus
                                    )
                                 ">
                              </app-compliance-status-card>
                           </ng-container>
                        </section>

                        <section class="px-3 pt-4" *ngIf="
                              checkSelectedTab(activatedTabIndex, 'Profile') &&
                              stock.companyProfile.ticker
                           ">
                           <app-stock-profile [profileDescription]="
                                 stock.companyProfile.description
                              " [market]="stock.companyProfile.country"
                              [sector]="stock.companyProfile.musaffaSectorName" [industry]="
                                 stock.companyProfile.musaffaIndustryName
                              " [exchange]="stock.companyProfile.exchange" [website]="stock.companyProfile.weburl"
                              [phone]="stock.companyProfile.phone" [address]="stock.companyProfile.address"
                              [currentPrice]="fundamentals?.currentPrice">
                           </app-stock-profile>
                        </section>
                     </ng-container>

                     <ng-template #coveredComplaiance>
                        <div class="mobile-sticky-tabs">
                           <app-details-tab-btns [activeTab]="activatedTabIndex" [tabsType]="'bordered'"
                              [tabs]="getTabs()" (onTabChange)="tabChange($event)">
                           </app-details-tab-btns>
                        </div>

                        <section class="" [hidden]="
                              !checkSelectedTab(activatedTabIndex, 'Overview')
                           " *ngIf="stock.companyProfile.ticker">
                           <ng-container>
                              <app-compliance-status-card [stockType]="type" [isin]="stock.companyProfile.isin"
                                 [mainTicker]="stock.companyProfile.mainTicker" *ngIf="
                                    shariahCompliantStatus && complianceMetaLoaded
                                 " [complianceStatus]="shariahCompliantStatus" [complianceRanking]="
                                    stock.companyProfile.ranking_v2
                                 " [complianceRankingV2]="stock.companyProfile.ranking_v2"
                                 [ticker]="stock.companyProfile.ticker" [countryCode]="stock.companyProfile.country"
                                 [canViewScreeningReport]="canViewScreeningReport" [lastUpdate]="lastUpdate"
                                 [reportDate]="reportDate" [reportTypeSection]="reportTypeSection"
                                 [reportTypeYear]="reportTypeYear" (goToComplianceTab)="
                                    onGoToComplianceTab(
                                       stock.companyProfile.ticker,
                                       stock.companyProfile
                                          ?.shariahCompliantStatus
                                    )
                                 ">
                              </app-compliance-status-card>
                           </ng-container>
                        </section>
                        <section class="px-3 pt-4" *ngIf="
                              isBrowser &&
                              checkSelectedTab(
                                 activatedTabIndex,
                                 'Shariah Compliance Report'
                              ) &&
                              stock.companyProfile.ticker
                           ">
                           <!-- <app-limit-reached-card></app-limit-reached-card> -->
                           <ng-container *ngIf="showComplianceReport">
                              <div *ngIf="
                                    this.reportFormat == 'NEW' ||
                                       stock.companyProfile
                                          ?.shariahCompliantStatus == 'LOCKED';
                                    else oldReport
                                 ">
                                 <app-screener-report [storedResponse]="screenerReportResponse"
                                    (responseLoaded)="screenerDataLoaded($event)"
                                    [companyProfile]="stock.companyProfile">
                                 </app-screener-report>
                              </div>
                              <ng-template #oldReport>
                                 <app-tooltip [profile]="stock.companyProfile" [results]="results"
                                    [position]="tooltipPosition" [renenueRatio]="this.renenueRatio"
                                    [interestBearingSecurities]="
                                       this.interestBearingSecurities
                                    " [interestBearingDebt]="
                                       this.interestBearingDebt
                                    ">
                                 </app-tooltip>
                              </ng-template>
                           </ng-container>
                           <ng-container *ngIf="!showComplianceReport">
                              <app-feature-locked-card heading="Shariah Compliance Report"
                                 text="An extensive business and financial screening of the company which specifies why a stock is halal or haram!"
                                 (viewSampleClicked)="
                                    onViewSampleClicked('report')
                                 " componentPage="shariah_compliance_report">
                              </app-feature-locked-card>
                           </ng-container>
                        </section>

                        <section class="px-3 pt-4" *ngIf="
                              checkSelectedTab(activatedTabIndex, 'Profile') &&
                              stock.companyProfile.ticker
                           ">
                           <app-stock-profile [profileDescription]="
                                 stock.companyProfile.description
                              " [market]="stock.companyProfile.country"
                              [sector]="stock.companyProfile.musaffaSectorName" [industry]="
                                 stock.companyProfile.musaffaIndustryName
                              " [exchange]="stock.companyProfile.exchange" [website]="stock.companyProfile.weburl"
                              [phone]="stock.companyProfile.phone" [address]="stock.companyProfile.address"
                              [currentPrice]="fundamentals?.currentPrice">
                           </app-stock-profile>
                        </section>
                     </ng-template>
                  </ng-container>
               </section>
            </div>

            <div class="desktop-stock-details-wrapper" *ngIf="!isMobile && stock.companyProfile">
               <section class="left-section">
                  <div class="grey-box stock-details-header overflow-hidden">
                     <app-details-header [item]="stock.companyProfile" [logoUrl]="stock.companyProfile.logo"
                        [stockName]="stock.companyProfile.name" [stockTicker]="stock.companyProfile.ticker"
                        [currentPrice]="fundamentals?.currentPrice" [currency]="stock.companyProfile.currency"
                        [priceChange]="fundamentals?.change" [percentChange]="percentChange"
                        [countryName]="fullCountryName" [sectorName]="stock.companyProfile.musaffaSectorName"
                        [marketCap]="
                           stock.companyProfile.marketCapClassification
                        " [lastDate]="fundamentals.fullDatetime" [stockExchange]="stock.companyProfile.exchange"
                        [isShown]="isShown" [isAddedInWatchlist]="isAddedInWatchlist" [countryCode]="countryName"
                        (openAddLists)="isShown = true" [stockType]="'Stock'" [chartTicker]="chartTicker"
                        [showTradingViewTicker]="showTradingViewChart">
                     </app-details-header>

                     <div class="pb-4" *ngIf="
                           !isBuySellLoading &&
                           showBuySellComponent &&
                           shariahCompliantStatus
                        ">
                        <app-buysell [complianceStatus]="shariahCompliantStatus" [symbol]="id" [exchange]="exchangeCode"
                           [userRole]="userRole">
                        </app-buysell>
                     </div>
                  </div>

                  <ng-container>
                     <app-compliance-status-card [stockType]="type" [isin]="stock.companyProfile.isin"
                        [mainTicker]="stock.companyProfile.mainTicker"
                        *ngIf="shariahCompliantStatus && complianceMetaLoaded"
                        [complianceStatus]="shariahCompliantStatus"
                        [complianceRanking]="stock.companyProfile.ranking_v2" [complianceRankingV2]="stock.companyProfile.ranking_v2"
                        [ticker]="stock.companyProfile.ticker"
                        [countryCode]="stock.companyProfile.country" [canViewScreeningReport]="canViewScreeningReport"
                        [lastUpdate]="lastUpdate" [reportDate]="reportDate" [reportTypeSection]="reportTypeSection"
                        [reportTypeYear]="reportTypeYear" (goToComplianceTab)="
                           onGoToComplianceTab(
                              stock.companyProfile.ticker,
                              shariahCompliantStatus
                           )
                        ">
                     </app-compliance-status-card>
                  </ng-container>

                  <ng-container *ngIf="isCoveredCountry()">
                     <ng-container>
                        <app-purification-card [complianceStatus]="shariahCompliantStatus"
                           [stockName]="stock.companyProfile.name" [stockTicker]="stock.companyProfile.ticker">
                        </app-purification-card>
                     </ng-container>

                     <ng-container *ngIf="analystRatingsVisibility">
                        <app-stock-recommendation [ticker]="id" [showLabel]="shariahCompliantStatus == 'COMPLIANT'"
                           [stockname]="stock.companyProfile.name" [stockComplianceRating]="shariahCompliantStatus"
                           id="Analysts-Ratings">
                        </app-stock-recommendation>
                     </ng-container>

                     <!-- <div
                        *ngIf="
                           investmentChecklistVisibility && showInvestmentChecklist
                        "
                     >
                        <app-investment-checklist
                           *ngIf="shariahCompliantStatus"
                           [ticker]="id"
                           [countryCode]="stock.companyProfile.country"
                           [currency]="currency"
                           [status]="shariahCompliantStatus"
                        >
                        </app-investment-checklist>
                     </div> -->
                     <!-- New one -->
                     <div *ngIf="
                           investmentChecklistVisibility && showInvestmentChecklist && countryName === 'US'
                        ">
                        <app-new-investment-checklist *ngIf="shariahCompliantStatus" [ticker]="id"
                           [countryCode]="stock.companyProfile.country" [currency]="currency"
                           [status]="shariahCompliantStatus">
                        </app-new-investment-checklist>
                     </div>
                  </ng-container>
               </section>

               <section class="right-section">
                  <app-company-info [stockName]="stock.companyProfile.name" [reportTypeSection]="reportTypeSection"
                     [reportTypeYear]="reportTypeYear"
                     [stockDescription]="stock.companyProfile.description" [stockLogo]="stock.companyProfile.logo"
                     [stockTicker]="stock.companyProfile.ticker" [fullCountryName]="fullCountryName" [stock]="stock"
                     [lastUpdate]="lastUpdate"
                     [type]="type"></app-company-info>
                  <ng-container *ngIf="isCoveredCountry()">
                     <div class="desktop-sticky-tabs">
                        <app-details-tab-btns [activeTab]="activatedTabIndex" [tabsType]="'bordered'" [tabs]="getTabs()"
                           (onTabChange)="tabChange($event)" [stockOverviewTab]="'stock_overview_tab'">
                        </app-details-tab-btns>
                     </div>

                     <section [hidden]="!checkSelectedTab(activatedTabIndex, 'Overview')"
                        *ngIf="stock.companyProfile.id">
                        <ng-container>
                           <div class="p-4 mt-32 br-10 grey-box" *ngIf="showChart">
                              <div class="d-flex align-items-center justify-content-between flex-wrap mb-4">
                                 <h4 class="company-chart-name mb-0 fw-600">
                                    <span>{{stock.companyProfile.name}} ({{stock.companyProfile.id}})</span>
                                    Chart
                                 </h4>
                                 <!-- <div class="chips-container d-flex align-items-center flex-wrap gap-2">
                                    <span
                                       class="stock-chip cursor-pointer d-flex align-items-center ps-2 gap-2 text-nowrap rounded-pill"
                                       *ngIf="fullCountryName" [routerLink]="'/stock-screener'" [queryParams]="{
                                          country: stock.companyProfile.country,
                                          page: 1
                                       }">
                                       <img
                                          [appLazyLoadImage]="'/assets/flags/1x1/' + stock.companyProfile.country?.toLowerCase() + '.svg'"
                                          width="16" height="16" class="img-fluid rounded-circle" priority
                                          [alt]="fullCountryName + ' flag'" />
                                       <span>{{ fullCountryName }}</span>
                                    </span>
                                    <span class="stock-chip cursor-pointer text-nowrap rounded-pill" *ngIf="
                                          stock.companyProfile.musaffaSectorName
                                       " [routerLink]="'/stock-screener'" [queryParams]="{
                                          country: stock.companyProfile.country,
                                          page: 1,
                                          sectors:
                                             stock.companyProfile
                                                .musaffaSectorName
                                       }">
                                       {{
                                       stock.companyProfile.musaffaSectorName
                                       }}
                                    </span>
                                    <span class="stock-chip cursor-pointer text-nowrap rounded-pill" *ngIf="
                                          stock.companyProfile
                                             ?.marketCapClassification
                                       " [routerLink]="'/stock-screener'" [queryParams]="{
                                          country: stock.companyProfile.country,
                                          page: 1,
                                          marketCapClassification:
                                             stock.companyProfile
                                                .marketCapClassification
                                       }">
                                       {{
                                       stock.companyProfile
                                       .marketCapClassification
                                       | categoryToText
                                       | titlecase
                                       }}
                                    </span>
                                 </div> -->
                              </div>
                              <app-trading-view *ngIf="showTradingViewChart" [isMobile]="isMobile"
                                 [symbol]="chartTicker" (hasData)="chartEvent($event)">
                              </app-trading-view>
                              <app-trading-chart *ngIf="!showTradingViewChart" [ticker]="stock.companyProfile.ticker"
                                 [currency]="stock.companyProfile.currency" (getPrice)="getStartPrice($event)"
                                 (hasData)="chartEvent($event)">
                              </app-trading-chart>
                           </div>
                           <!-- <ng-template #noChart>
                              <app-no-data-card heading="Chart"></app-no-data-card>
                           </ng-template> -->
                        </ng-container>
                        <div class="mt-32">
                           <app-market-comparison [name]="stock.companyProfile.name"
                              [ticker]="stock.companyProfile.ticker" [data]="stockData"
                              [indexData]="stockIndices"></app-market-comparison>
                        </div>
                        <ng-container *ngIf="keyStatisticsVisibility">
                           <div class="mt-32" *ngIf="
                                 stock &&
                                 stock.companyProfile &&
                                 fundamentals &&
                                 fundamentals.todaysOpen
                              ">
                              <app-fundamentals [stock]="stock" [fundamentals]="fundamentals"
                                 [currency]="stock.companyProfile.currency"></app-fundamentals>
                           </div>
                        </ng-container>

                        <div class="mt-32 mb-4">
                           <h3 class="fms-heading mb-0 fw-600">
                              Financial Metrics & Statements of {{stock.companyProfile.name}} ({{stock.companyProfile.ticker}})
                           </h3>
                           <app-stock-financials [ticker]="stock.companyProfile.ticker" *ngIf="isBrowser"></app-stock-financials>
                        </div>

                        <app-superinvestors-stock-overview-list [name]="stock.companyProfile.name" [ticker]="stock.companyProfile.ticker"></app-superinvestors-stock-overview-list>

                        <app-top-user-collections [showSymbolsList]="true" [styleType]="'card'"
                           [symbol]="stock.companyProfile.ticker" [sectionHeading]="'Community-Curated Collections with ' + stock.companyProfile.name + ' (' + stock.companyProfile.ticker + ')'"
                           [showMessage]="false">
                        </app-top-user-collections>
                        <div class="mt-32">
                           <app-faqs [name]="stock.companyProfile.name" [ticker]="stock.companyProfile.ticker" [halalStatus]="halalStatus" [monthYear]="monthYear" [type]="'stock'"></app-faqs>
                        </div>
                        <ng-container *ngIf="relatedStocksVisibility">
                           <app-related-stocks [musaffaIndustryName]="
                                 stock.companyProfile.musaffaIndustryName
                              " [musaffaSectorName]="
                                 stock.companyProfile.musaffaSectorName
                              " [marketCapClassification]="
                                 stock.companyProfile.marketCapClassification
                              " [country]="stock.companyProfile.country" [gsubind]="stock.companyProfile.gsubind"
                              [ticker]="stock.companyProfile.ticker" [complianceStatus]="shariahCompliantStatus"
                              [name]="stock.companyProfile.name"
                              [finnhubIndustry]="
                                 stock.companyProfile.finnhubIndustry
                              " [gsector]="stock.companyProfile.gsector" id="Related-Companies">
                           </app-related-stocks>
                        </ng-container>
                     </section>
                     <section class="mt-32" *ngIf="
                           checkSelectedTab(
                              activatedTabIndex,
                              'Shariah Compliance Report'
                           ) && stock.companyProfile.ticker
                        ">
                        <!-- <app-limit-reached-card></app-limit-reached-card> -->
                        <ng-container *ngIf="showComplianceReport">
                           <div *ngIf="
                                 reportFormat == 'NEW' ||
                                    shariahCompliantStatus == 'LOCKED';
                                 else oldReport
                              ">
                              <app-screener-report [storedResponse]="screenerReportResponse"
                                 (responseLoaded)="screenerDataLoaded($event)" [companyProfile]="stock.companyProfile">
                              </app-screener-report>
                           </div>
                           <ng-template #oldReport>
                              <app-tooltip [profile]="stock.companyProfile" [results]="results"
                                 [position]="tooltipPosition" [renenueRatio]="this.renenueRatio"
                                 [interestBearingSecurities]="
                                    this.interestBearingSecurities
                                 " [interestBearingDebt]="this.interestBearingDebt">
                              </app-tooltip>
                           </ng-template>
                        </ng-container>
                        <ng-container *ngIf="!showComplianceReport">
                           <app-feature-locked-card heading="Shariah Compliance Report"
                              text="An extensive business and financial screening of the company which specifies why a stock is halal or haram!"
                              (viewSampleClicked)="onViewSampleClicked('report')"
                              componentPage="shariah_compliance_report">
                           </app-feature-locked-card>
                        </ng-container>
                     </section>
                     <section class="mt-32" *ngIf="
                           isBrowser &&
                           showIriReport &&
                           checkSelectedTab(activatedTabIndex, 'IRI Report') &&
                           stock.companyProfile.ticker
                        ">
                        <ng-container>
                           <app-iri-report [symbol]="this.stock.companyProfile.ticker" [symbolMainTicker]="
                                 this.stock.companyProfile.mainTicker" [isSubscribed]="isSubscribed" 
                            [userRoleNew]="userRoleNew" [country]="stock.companyProfile.country"></app-iri-report>
                        </ng-container>
                     </section>

                     <section class="mt-32" *ngIf="
                           isBrowser &&
                           checkSelectedTab(activatedTabIndex, 'Financials') &&
                           stock.companyProfile.ticker
                        ">
                        <ng-container>
                           <app-stock-financials [ticker]="stock.companyProfile.ticker"></app-stock-financials>
                           <!-- <div class="" *ngIf="isAllowedCountry; else noForecast">
                              <app-forecasts [ticker]="stock.companyProfile.ticker"
                                 [currency]="stock.companyProfile.currency" [fundamentals]="fundamentals">
                              </app-forecasts>
                           </div>
                           <ng-template #noForecast>
                              <app-no-data-card heading="Forecasts"></app-no-data-card>
                           </ng-template> -->
                        </ng-container>
                     </section>

                     <section class="mt-32" *ngIf="
                           checkSelectedTab(activatedTabIndex, 'Forecast') &&
                           stock.companyProfile.ticker
                        ">
                        <ng-container *ngIf="forecastVisibility">
                           <div class="" *ngIf="isAllowedCountry; else noForecast">
                              <app-forecasts [ticker]="stock.companyProfile.ticker"
                                 [currency]="stock.companyProfile.currency" [fundamentals]="fundamentals">
                              </app-forecasts>
                           </div>
                           <ng-template #noForecast>
                              <app-no-data-card heading="Forecasts"></app-no-data-card>
                           </ng-template>
                        </ng-container>
                     </section>

                     <section class="mt-32" *ngIf="
                           checkSelectedTab(activatedTabIndex, 'News') &&
                           stock.companyProfile.ticker
                        ">
                        <ng-container *ngIf="newsVisibility">
                           <app-stock-news [ticker]="stock.companyProfile.ticker" id="Latest-News">
                           </app-stock-news>
                        </ng-container>

                        <ng-container *ngIf="pressReleaseVisibility">
                           <app-stock-press-releases [handleHeader]="'show'" [symbol]="stock.companyProfile.ticker"
                              id="Press-Releases">
                           </app-stock-press-releases>
                        </ng-container>
                     </section>

                     <section class="mt-32" *ngIf="
                           checkSelectedTab(activatedTabIndex, 'Profile') &&
                           stock.companyProfile.ticker
                        ">
                        <app-stock-profile [profileDescription]="
                              stock.companyProfile.description
                           " [market]="stock.companyProfile.country" [sector]="stock.companyProfile.musaffaSectorName"
                           [industry]="stock.companyProfile.musaffaIndustryName"
                           [exchange]="stock.companyProfile.exchange" [website]="stock.companyProfile.weburl"
                           [phone]="stock.companyProfile.phone" [address]="stock.companyProfile.address"
                           [currentPrice]="fundamentals?.currentPrice">
                        </app-stock-profile>
                     </section>
                  </ng-container>

                  <ng-container *ngIf="!isCoveredCountry()">
                     <ng-container *ngIf="
                           shariahCompliantStatus === 'NOT_UNDER_COVERAGE';
                           else coveredComp
                        ">
                        <div class="desktop-sticky-tabs">
                           <app-details-tab-btns [activeTab]="activatedTabIndex" [tabsType]="'bordered'"
                              [tabs]="getTabs()" (onTabChange)="tabChange($event)">
                           </app-details-tab-btns>
                        </div>

                        <section class="mt-32" *ngIf="
                              checkSelectedTab(activatedTabIndex, 'Overview') &&
                              stock.companyProfile.ticker
                           ">
                           <app-stock-profile [profileDescription]="
                                 stock.companyProfile.description
                              " [market]="stock.companyProfile.country"
                              [sector]="stock.companyProfile.musaffaSectorName" [industry]="
                                 stock.companyProfile.musaffaIndustryName
                              " [exchange]="stock.companyProfile.exchange" [website]="stock.companyProfile.weburl"
                              [phone]="stock.companyProfile.phone" [address]="stock.companyProfile.address"
                              [currentPrice]="fundamentals?.currentPrice">
                           </app-stock-profile>
                        </section>
                     </ng-container>

                     <ng-template #coveredComp>
                        <div class="desktop-sticky-tabs">
                           <app-details-tab-btns [activeTab]="activatedTabIndex" [tabsType]="'bordered'"
                              [tabs]="getTabs()" (onTabChange)="tabChange($event)">
                           </app-details-tab-btns>
                        </div>

                        <section class="mt-32" *ngIf="
                              checkSelectedTab(
                                 activatedTabIndex,
                                 'Shariah Compliance Report'
                              ) && stock.companyProfile.ticker
                           ">
                           <!-- <app-limit-reached-card></app-limit-reached-card> -->
                           <ng-container *ngIf="showComplianceReport">
                              <div *ngIf="
                                    reportFormat == 'NEW' ||
                                       stock.companyProfile
                                          ?.shariahCompliantStatus == 'LOCKED';
                                    else oldReport
                                 ">
                                 <app-screener-report [storedResponse]="screenerReportResponse"
                                    (responseLoaded)="screenerDataLoaded($event)"
                                    [companyProfile]="stock.companyProfile">
                                 </app-screener-report>
                              </div>
                              <ng-template #oldReport>
                                 <app-tooltip [profile]="stock.companyProfile" [results]="results"
                                    [position]="tooltipPosition" [renenueRatio]="this.renenueRatio"
                                    [interestBearingSecurities]="
                                       this.interestBearingSecurities
                                    " [interestBearingDebt]="
                                       this.interestBearingDebt
                                    ">
                                 </app-tooltip>
                              </ng-template>
                           </ng-container>
                           <ng-container *ngIf="!showComplianceReport">
                              <app-feature-locked-card heading="Shariah Compliance Report"
                                 text="An extensive business and financial screening of the company which specifies why a stock is halal or haram!"
                                 (viewSampleClicked)="
                                    onViewSampleClicked('report')
                                 " componentPage="shariah_compliance_report">
                              </app-feature-locked-card>
                           </ng-container>
                        </section>

                        <section class="mt-32" *ngIf="
                              checkSelectedTab(activatedTabIndex, 'Profile') &&
                              stock.companyProfile.ticker
                           ">
                           <app-stock-profile [profileDescription]="
                                 stock.companyProfile.description
                              " [market]="stock.companyProfile.country"
                              [sector]="stock.companyProfile.musaffaSectorName" [industry]="
                                 stock.companyProfile.musaffaIndustryName
                              " [exchange]="stock.companyProfile.exchange" [website]="stock.companyProfile.weburl"
                              [phone]="stock.companyProfile.phone" [address]="stock.companyProfile.address"
                              [currentPrice]="fundamentals?.currentPrice">
                           </app-stock-profile>
                        </section>
                     </ng-template>
                  </ng-container>
               </section>
            </div>
         </ng-container>
         <app-add-lists *ngIf="isShown" [appearance]="isShown" (close)="closeWatchListUi()"
            [stock]="stock.companyProfile">
         </app-add-lists>
      </ng-container>
   </main>
</app-main-wrapper>
